import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTradeDealApi, deleteTradeDealApi, toggleTradeDealPublishedStateApi } from './tradeDealSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Datatable from '~/components/Datatable';

function TradeDeal() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.shopSaga.tradeDeal);
    console.log(rows);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                width: '3rem',
            },
            {
                name: 'deal_type',
                selector: (row) => row.deal_type,
                sortable: true,
            },
            {
                name: 'receive_item_id',
                selector: (row) => row.receive_item_id.toString(),
                sortable: true,
            },
            {
                name: 'receive_item_quantity',
                selector: (row) => row.receive_item_quantity.toString(),
                sortable: true,
            },
            {
                name: 'pay_item_id',
                selector: (row) => row.pay_item_id.toString(),
                sortable: true,
            },
            {
                name: 'pay_item_quantity',
                selector: (row) => row.pay_item_quantity.toString(),
                sortable: true,
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        row={row}
                        thunkFunc={deleteTradeDealApi}
                    />
                ),
            },
            {
                name: 'Published',
                cell: (row) => (
                    <Form.Check
                        type="switch"
                        id={'published-' + row.id}
                        onChange={() => {
                            dispatch(toggleTradeDealPublishedStateApi(row));
                        }}
                        checked={row.is_ready}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchTradeDealApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-12">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default TradeDeal;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
